<router-outlet></router-outlet>
<ng-container *ngIf="showChatWidget">
    <app-chat-widget></app-chat-widget>
</ng-container>
<route-loader></route-loader>
<!--
    Live notification toasts. Viewport-level chrome, so it belongs here beside
    route-loader rather than inside <layout>: `layout > *` in styles.scss forces
    every direct child to `flex: 1 1 auto; width: 100%`, which would make the
    toast host a second flex item and squeeze the app into half the screen.
-->
<notification-toast></notification-toast>
<ng-container *ngIf="showQuickTour">
    <sai-quick-tour></sai-quick-tour>
</ng-container>
